import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

type ReportOptions = string | object | number | null;
// Define the context type
interface PrintContextType {
  TabOption: {tabName:string |null , subOption:string | null, reportOptions?: ReportOptions[]};
  setTabOption: ({tabName, subOption, reportOptions} : {tabName: string | null, subOption: string | null, reportOptions?: ReportOptions[]}) => void;
  reportOptions?: ReportOptions;
}

// Create the PrintContext
const PrintContext = createContext<PrintContextType | undefined>(undefined);

// Custom hook to use the PrintContext
export const usePrint = (): PrintContextType => {
  const context = useContext(PrintContext);
  if (!context) {
    throw new Error('usePrint must be used within a PrintProvider');
  }
  return context;
};

// PrintProvider component to wrap the app
export const PrintProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  
  const [tabOptionState, setTabOptionState] = useState<{tabName: string | null, subOption: string | null, reportOptions?: ReportOptions[]}>({tabName: null, subOption: null, reportOptions: []});
  
  const setTabOption = useCallback(({ tabName, subOption, reportOptions }: { tabName: string | null, subOption: string | null, reportOptions?: ReportOptions[] }) => {
    setTabOptionState({ tabName, subOption, reportOptions });
  }, []);

  const contextValue = React.useMemo(() => ({ TabOption: tabOptionState, setTabOption }), [tabOptionState, setTabOption]);

  return (
    <PrintContext.Provider value={contextValue}>
      {children}
    </PrintContext.Provider>
  );
};